import { commonjsGlobal as t } from "./index832.mjs";
var o = function(e) {
  return e && e.Math === Math && e;
}, c = (
  // eslint-disable-next-line es/no-global-this -- safe
  o(typeof globalThis == "object" && globalThis) || o(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  o(typeof self == "object" && self) || o(typeof t == "object" && t) || o(typeof t == "object" && t) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
);
export {
  c as g
};
